/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IArticleDetailsData } from './article-details.data';
import { IArticleDetailsProps } from './article-details.props.autogenerated';
import { ProductsDataActions, AttributeProduct } from '@msdyn365-commerce/retail-proxy/';
export interface IArticleDetailsViewProps extends IArticleDetailsProps<IArticleDetailsData> {
    productId: string;
    modelInfo: string;
    attributes: AttributeProduct[] | undefined;
}

/**
 *
 * ArticleDetails component
 * @extends {React.PureComponent<IArticleDetailsProps<IArticleDetailsData>>}
 */
class ArticleDetails extends React.PureComponent<IArticleDetailsProps<IArticleDetailsData>> {
    public render(): JSX.Element | null {
        const {
            data: { product }
        } = this.props;

        const productId = product.result && product.result.ItemId ? product.result.ItemId : '';
        const attributes = ProductsDataActions.getChannelProductAttributesAsync(this.context);
        const modelInfo = attributes.result ? attributes.result.find(n => n.Name === 'ModelSize') : '';

        const articleDetailsProps: IArticleDetailsViewProps = {
            ...this.props,
            productId,
            modelInfo: modelInfo && modelInfo.Name ? modelInfo.Name : '',
            attributes: attributes.result
        };

        return this.props.renderView(articleDetailsProps);
    }
}

export default ArticleDetails;
